import { CSSProperties } from "react";

export const BrokenCarIcon = ({
  className,
  style,
}: {
  className?: string;
  style?: CSSProperties;
}) => (
  <svg
    className={className}
    style={style}
    width="299"
    height="186"
    viewBox="0 0 299 186"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Broken car</title>
    <path
      d="M219.317 165.772C219.317 176.391 210.793 184.999 200.279 184.999C189.764 184.999 181.24 176.391 181.24 165.772C181.24 155.153 189.764 146.545 200.279 146.545C210.793 146.545 219.317 155.153 219.317 165.772Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M200.279 147.295C190.185 147.295 181.99 155.56 181.99 165.772C181.99 175.984 190.185 184.249 200.279 184.249C210.372 184.249 218.567 175.984 218.567 165.772C218.567 155.56 210.372 147.295 200.279 147.295ZM180.49 165.772C180.49 154.746 189.343 145.795 200.279 145.795C211.215 145.795 220.067 154.746 220.067 165.772C220.067 176.798 211.215 185.749 200.279 185.749C189.343 185.749 180.49 176.798 180.49 165.772Z"
      fill="#090A0B"
    />
    <path
      d="M225.663 165.772C225.663 176.391 217.14 184.999 206.625 184.999C196.11 184.999 187.586 176.391 187.586 165.772C187.586 155.153 196.11 146.545 206.625 146.545C217.14 146.545 225.663 155.153 225.663 165.772Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M206.625 147.295C196.531 147.295 188.336 155.56 188.336 165.772C188.336 175.984 196.531 184.249 206.625 184.249C216.718 184.249 224.913 175.984 224.913 165.772C224.913 155.56 216.718 147.295 206.625 147.295ZM186.836 165.772C186.836 154.746 195.689 145.795 206.625 145.795C217.561 145.795 226.413 154.746 226.413 165.772C226.413 176.798 217.561 185.749 206.625 185.749C195.689 185.749 186.836 176.798 186.836 165.772Z"
      fill="#090A0B"
    />
    <path
      d="M102.317 165.772C102.317 176.391 93.7933 184.999 83.2787 184.999C72.764 184.999 64.2402 176.391 64.2402 165.772C64.2402 155.153 72.764 146.545 83.2787 146.545C93.7933 146.545 102.317 155.153 102.317 165.772Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M83.2787 147.295C73.1852 147.295 64.9902 155.56 64.9902 165.772C64.9902 175.984 73.1852 184.249 83.2787 184.249C93.3722 184.249 101.567 175.984 101.567 165.772C101.567 155.56 93.3722 147.295 83.2787 147.295ZM63.4902 165.772C63.4902 154.746 72.3429 145.795 83.2787 145.795C94.2145 145.795 103.067 154.746 103.067 165.772C103.067 176.798 94.2145 185.749 83.2787 185.749C72.3429 185.749 63.4902 176.798 63.4902 165.772Z"
      fill="#090A0B"
    />
    <path
      d="M108.663 165.772C108.663 176.391 100.14 184.999 89.6249 184.999C79.1102 184.999 70.5864 176.391 70.5864 165.772C70.5864 155.153 79.1102 146.545 89.6249 146.545C100.14 146.545 108.663 155.153 108.663 165.772Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M89.6249 147.295C79.5314 147.295 71.3364 155.56 71.3364 165.772C71.3364 175.984 79.5314 184.249 89.6249 184.249C99.7184 184.249 107.913 175.984 107.913 165.772C107.913 155.56 99.7184 147.295 89.6249 147.295ZM69.8364 165.772C69.8364 154.746 78.6891 145.795 89.6249 145.795C100.561 145.795 109.413 154.746 109.413 165.772C109.413 176.798 100.561 185.749 89.6249 185.749C78.6891 185.749 69.8364 176.798 69.8364 165.772Z"
      fill="#090A0B"
    />
    <path
      d="M90.125 22.5C90.125 34.9264 80.0514 45 67.625 45C55.1986 45 45.125 34.9264 45.125 22.5C45.125 10.0736 55.1986 0 67.625 0C80.0514 0 90.125 10.0736 90.125 22.5Z"
      fill="#DEE0E2"
    />
    <path
      d="M117.67 31.2723C117.67 41.3637 109.489 49.5445 99.3973 49.5445C89.3058 49.5445 81.125 41.3637 81.125 31.2723C81.125 21.1808 89.3058 13 99.3973 13C109.489 13 117.67 21.1808 117.67 31.2723Z"
      fill="#DEE0E2"
    />
    <path
      d="M38.125 43.4319C38.125 53.9253 29.6184 62.4319 19.125 62.4319C8.63159 62.4319 0.125 53.9253 0.125 43.4319C0.125 32.9385 8.63159 24.4319 19.125 24.4319C29.6184 24.4319 38.125 32.9385 38.125 43.4319Z"
      fill="#DEE0E2"
    />
    <path
      d="M34.5452 90.7101C34.5452 93.8637 31.9887 96.4202 28.8351 96.4202C25.6815 96.4202 23.125 93.8637 23.125 90.7101C23.125 87.5565 25.6815 85 28.8351 85C31.9887 85 34.5452 87.5565 34.5452 90.7101Z"
      fill="#DEE0E2"
    />
    <path
      d="M53.125 29.4319C53.125 35.5071 48.2001 40.4319 42.125 40.4319C36.0498 40.4319 31.125 35.5071 31.125 29.4319C31.125 23.3568 36.0498 18.4319 42.125 18.4319C48.2001 18.4319 53.125 23.3568 53.125 29.4319Z"
      fill="#DEE0E2"
    />
    <path
      d="M6.9771 62.426C6.9771 64.3182 5.4432 65.8521 3.55105 65.8521C1.65889 65.8521 0.125 64.3182 0.125 62.426C0.125 60.5339 1.65889 59 3.55105 59C5.4432 59 6.9771 60.5339 6.9771 62.426Z"
      fill="#DEE0E2"
    />
    <path
      d="M17.6931 90.7873C17.6931 92.0488 16.6705 93.0713 15.409 93.0713C14.1476 93.0713 13.125 92.0488 13.125 90.7873C13.125 89.5259 14.1476 88.5033 15.409 88.5033C16.6705 88.5033 17.6931 89.5259 17.6931 90.7873Z"
      fill="#DEE0E2"
    />
    <path
      d="M92.9064 5.13613C92.9064 6.39756 91.8839 7.42016 90.6224 7.42016C89.361 7.42016 88.3384 6.39756 88.3384 5.13613C88.3384 3.87469 89.361 2.8521 90.6224 2.8521C91.8839 2.8521 92.9064 3.87469 92.9064 5.13613Z"
      fill="#DEE0E2"
    />
    <path
      d="M71.125 88.5C71.125 98.165 63.29 106 53.625 106C43.96 106 36.125 98.165 36.125 88.5C36.125 78.835 43.96 71 53.625 71C63.29 71 71.125 78.835 71.125 88.5Z"
      fill="#DEE0E2"
    />
    <path
      d="M80.3442 102.207C80.3442 107.884 75.7426 112.486 70.0661 112.486C64.3896 112.486 59.788 107.884 59.788 102.207C59.788 96.531 64.3896 91.9293 70.0661 91.9293C75.7426 91.9293 80.3442 96.531 80.3442 102.207Z"
      fill="#DEE0E2"
    />
    <path
      d="M86.3106 112.298C85.6972 112.428 85.0611 112.496 84.4091 112.496C79.3494 112.496 75.2477 108.394 75.2477 103.334C75.2477 100.581 76.4623 98.1113 78.385 96.4319C74.2378 97.3073 71.125 100.988 71.125 105.396C71.125 110.456 75.2267 114.557 80.2865 114.557C82.5928 114.557 84.7001 113.705 86.3106 112.298Z"
      fill="#DEE0E2"
    />
    <path
      d="M122.14 25.8877C122.14 18.6967 116.468 12.8672 109.472 12.8672C109.017 12.8672 108.567 12.8919 108.125 12.9399C109.588 12.3337 111.186 12 112.86 12C119.856 12 125.528 17.8294 125.528 25.0205C125.528 31.744 120.57 37.2773 114.206 37.9683C118.857 36.0408 122.14 31.3582 122.14 25.8877Z"
      fill="#DEE0E2"
    />
    <path
      d="M26.9637 82.7962C24.538 82.0973 22.2381 80.7836 20.3129 78.8585C14.3846 72.9301 14.2546 63.4483 20.0226 57.6803C22.7924 54.9105 26.4185 53.5007 30.0963 53.4399C25.0522 51.9868 19.4639 53.1924 15.569 57.0873C9.80094 62.8553 9.93092 72.3371 15.8593 78.2655C18.9409 81.3471 22.9825 82.8619 26.9637 82.7962Z"
      fill="#DEE0E2"
    />
    <path
      d="M80.125 58.9319C80.125 74.1198 67.589 86.4319 52.125 86.4319C36.661 86.4319 24.125 74.1198 24.125 58.9319C24.125 43.7441 36.661 31.4319 52.125 31.4319C67.589 31.4319 80.125 43.7441 80.125 58.9319Z"
      fill="#DEE0E2"
    />
    <path
      d="M89.2845 114.589C89.5049 114.532 89.6989 114.4 89.8344 114.217L116.625 78H202.209C204.391 78 206.478 78.8913 207.987 80.4674L228.125 101.5L244.578 118.701C248.138 122.423 250.125 127.375 250.125 132.525V155C250.125 161.627 244.752 167 238.125 167H43.125C41.4681 167 40.125 165.657 40.125 164V155V143.75V133.67C40.125 130.035 42.5765 126.856 46.0929 125.933L89.2845 114.589Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M116.247 77.25H202.209C204.596 77.25 206.879 78.2249 208.529 79.9487L228.667 100.981L245.12 118.182C248.813 122.044 250.875 127.181 250.875 132.525V155C250.875 162.042 245.167 167.75 238.125 167.75H43.125C41.0539 167.75 39.375 166.071 39.375 164V133.67C39.375 129.694 42.0563 126.217 45.9024 125.207L89.0939 113.864C89.149 113.85 89.1976 113.817 89.2314 113.771L116.247 77.25ZM117.003 78.75L90.4374 114.663C90.2002 114.984 89.8607 115.214 89.475 115.315L46.2834 126.658C43.0967 127.495 40.875 130.375 40.875 133.67V164C40.875 165.243 41.8824 166.25 43.125 166.25H238.125C244.338 166.25 249.375 161.213 249.375 155V132.525C249.375 127.568 247.462 122.802 244.036 119.219L227.583 102.019L207.446 80.9861C206.078 79.5578 204.186 78.75 202.209 78.75H117.003Z"
      fill="#090A0B"
    />
    <path
      d="M166.284 114.589C166.505 114.532 166.699 114.4 166.834 114.217L193.625 78H237.815C245.998 78 253.825 81.3424 259.484 87.2529L273.125 101.5L289.578 118.701C293.138 122.423 295.125 127.375 295.125 132.525V155C295.125 161.627 289.752 167 283.125 167H120.125C118.468 167 117.125 165.657 117.125 164V155V143.75V135.625V133.67C117.125 130.035 119.577 126.856 123.093 125.933L166.284 114.589Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M193.247 77.25H237.815C246.202 77.25 254.225 80.676 260.026 86.7342L273.667 100.981L290.12 118.182C293.813 122.044 295.875 127.181 295.875 132.525V155C295.875 162.042 290.167 167.75 283.125 167.75H120.125C118.054 167.75 116.375 166.071 116.375 164V133.67C116.375 129.694 119.056 126.217 122.902 125.207L166.094 113.864C166.149 113.85 166.198 113.817 166.231 113.771L193.247 77.25ZM194.003 78.75L167.437 114.663C167.2 114.984 166.861 115.214 166.475 115.315L123.283 126.658C120.097 127.495 117.875 130.375 117.875 133.67V164C117.875 165.243 118.882 166.25 120.125 166.25H283.125C289.338 166.25 294.375 161.213 294.375 155V132.525C294.375 127.568 292.462 122.802 289.036 119.219L272.583 102.019L258.942 87.7715C253.425 82.0089 245.793 78.75 237.815 78.75H194.003Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M175.375 146.5V114H176.875V146.5H175.375Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M235.375 146.5V114H236.875V146.5H235.375Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M190.139 50.9542C190.441 51.2382 190.455 51.7129 190.171 52.0144L165.671 78.0144C165.387 78.3158 164.912 78.3299 164.611 78.0458C164.309 77.7618 164.295 77.2871 164.579 76.9857L189.079 50.9857C189.363 50.6842 189.838 50.6701 190.139 50.9542Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.125 185.5C36.125 185.224 36.4634 185 36.8808 185L297.369 185C297.787 185 298.125 185.224 298.125 185.5C298.125 185.776 297.787 186 297.369 186L36.8808 186C36.4634 186 36.125 185.776 36.125 185.5Z"
      fill="#090A0B"
    />
    <path
      d="M40.125 169C40.125 167.895 41.0204 167 42.125 167H285.125C286.23 167 287.125 167.895 287.125 169C287.125 170.105 286.23 171 285.125 171H42.125C41.0204 171 40.125 170.105 40.125 169Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.375 169C39.375 167.481 40.6062 166.25 42.125 166.25H285.125C286.644 166.25 287.875 167.481 287.875 169C287.875 170.519 286.644 171.75 285.125 171.75H42.125C40.6062 171.75 39.375 170.519 39.375 169ZM42.125 167.75C41.4346 167.75 40.875 168.31 40.875 169C40.875 169.69 41.4346 170.25 42.125 170.25H285.125C285.815 170.25 286.375 169.69 286.375 169C286.375 168.31 285.815 167.75 285.125 167.75H42.125Z"
      fill="#090A0B"
    />
    <path
      d="M36.125 148C36.125 147.448 36.5727 147 37.125 147H296.125C296.677 147 297.125 147.448 297.125 148V154C297.125 154.552 296.677 155 296.125 155H37.125C36.5727 155 36.125 154.552 36.125 154V148Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.375 148C35.375 147.034 36.1585 146.25 37.125 146.25H296.125C297.091 146.25 297.875 147.033 297.875 148V154C297.875 154.966 297.091 155.75 296.125 155.75H37.125C36.1585 155.75 35.375 154.967 35.375 154V148ZM37.125 147.75C36.9869 147.75 36.875 147.862 36.875 148V154C36.875 154.138 36.9869 154.25 37.125 154.25H296.125C296.263 154.25 296.375 154.138 296.375 154V148C296.375 147.862 296.263 147.75 296.125 147.75H37.125Z"
      fill="#090A0B"
    />
    <path d="M36.125 154H297.125V156H36.125V154Z" fill="#090A0B" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.375 153.25H297.875V156.75H35.375V153.25ZM36.875 154.75V155.25H296.375V154.75H36.875Z"
      fill="#090A0B"
    />
    <path
      d="M230.125 83H199.849C198.466 83 197.181 83.6724 196.451 84.7781L176.125 114.059H236.125L230.125 83Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M195.83 84.3573C196.707 83.0351 198.23 82.25 199.849 82.25H230.125C230.484 82.25 230.793 82.5049 230.861 82.8577L236.861 113.917C236.904 114.136 236.846 114.364 236.703 114.536C236.561 114.709 236.349 114.809 236.125 114.809H176.125C175.846 114.809 175.59 114.654 175.46 114.406C175.331 114.159 175.35 113.86 175.509 113.631L195.83 84.3573ZM199.849 83.75C198.705 83.75 197.661 84.3067 197.077 85.1913L197.067 85.2058L177.559 113.309H235.216L229.506 83.75H199.849Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M223.125 119.5C223.125 118.672 223.797 118 224.625 118H229.625C230.453 118 231.125 118.672 231.125 119.5C231.125 120.328 230.453 121 229.625 121H224.625C223.797 121 223.125 120.328 223.125 119.5Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M287.125 131.25C287.125 130.836 287.461 130.5 287.875 130.5H294.375C294.789 130.5 295.125 130.836 295.125 131.25C295.125 131.664 294.789 132 294.375 132H287.875C287.461 132 287.125 131.664 287.125 131.25Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M287.125 135.25C287.125 134.836 287.461 134.5 287.875 134.5H294.375C294.789 134.5 295.125 134.836 295.125 135.25C295.125 135.664 294.789 136 294.375 136H287.875C287.461 136 287.125 135.664 287.125 135.25Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M287.125 139.25C287.125 138.836 287.461 138.5 287.875 138.5H294.375C294.789 138.5 295.125 138.836 295.125 139.25C295.125 139.664 294.789 140 294.375 140H287.875C287.461 140 287.125 139.664 287.125 139.25Z"
      fill="#090A0B"
    />
    <path
      d="M268.317 165.772C268.317 176.391 259.793 184.999 249.279 184.999C238.764 184.999 230.24 176.391 230.24 165.772C230.24 155.153 238.764 146.545 249.279 146.545C259.793 146.545 268.317 155.153 268.317 165.772Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M249.279 147.295C239.185 147.295 230.99 155.56 230.99 165.772C230.99 175.984 239.185 184.249 249.279 184.249C259.372 184.249 267.567 175.984 267.567 165.772C267.567 155.56 259.372 147.295 249.279 147.295ZM229.49 165.772C229.49 154.746 238.343 145.795 249.279 145.795C260.215 145.795 269.067 154.746 269.067 165.772C269.067 176.798 260.215 185.749 249.279 185.749C238.343 185.749 229.49 176.798 229.49 165.772Z"
      fill="#090A0B"
    />
    <path
      d="M255.625 139C240.437 139 228.125 151.434 228.125 166.773H283.125C283.125 151.434 270.813 139 255.625 139Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M228.885 166.023H282.365C281.972 151.439 270.144 139.75 255.625 139.75C241.106 139.75 229.278 151.439 228.885 166.023ZM227.375 166.773C227.375 151.027 240.016 138.25 255.625 138.25C271.234 138.25 283.875 151.027 283.875 166.773V167.523H227.375V166.773Z"
      fill="#090A0B"
    />
    <path
      d="M274.663 165.772C274.663 176.391 266.14 184.999 255.625 184.999C245.11 184.999 236.586 176.391 236.586 165.772C236.586 155.153 245.11 146.545 255.625 146.545C266.14 146.545 274.663 155.153 274.663 165.772Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M255.625 147.295C245.531 147.295 237.336 155.56 237.336 165.772C237.336 175.984 245.531 184.249 255.625 184.249C265.718 184.249 273.913 175.984 273.913 165.772C273.913 155.56 265.718 147.295 255.625 147.295ZM235.836 165.772C235.836 154.746 244.689 145.795 255.625 145.795C266.561 145.795 275.413 154.746 275.413 165.772C275.413 176.798 266.561 185.749 255.625 185.749C244.689 185.749 235.836 176.798 235.836 165.772Z"
      fill="#090A0B"
    />
    <path
      d="M266.731 165.773C266.731 171.967 261.758 176.988 255.625 176.988C249.491 176.988 244.519 171.967 244.519 165.773C244.519 159.578 249.491 154.557 255.625 154.557C261.758 154.557 266.731 159.578 266.731 165.773Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M255.625 155.307C249.912 155.307 245.269 159.985 245.269 165.773C245.269 171.56 249.912 176.238 255.625 176.238C261.337 176.238 265.981 171.56 265.981 165.773C265.981 159.985 261.337 155.307 255.625 155.307ZM243.769 165.773C243.769 159.171 249.07 153.807 255.625 153.807C262.18 153.807 267.481 159.171 267.481 165.773C267.481 172.374 262.18 177.738 255.625 177.738C249.07 177.738 243.769 172.374 243.769 165.773Z"
      fill="#090A0B"
    />
    <path
      d="M260.384 165.774C260.384 168.428 258.254 170.58 255.625 170.58C252.996 170.58 250.865 168.428 250.865 165.774C250.865 163.119 252.996 160.967 255.625 160.967C258.254 160.967 260.384 163.119 260.384 165.774Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M255.625 161.717C253.417 161.717 251.615 163.526 251.615 165.774C251.615 168.021 253.417 169.83 255.625 169.83C257.832 169.83 259.634 168.021 259.634 165.774C259.634 163.526 257.832 161.717 255.625 161.717ZM250.115 165.774C250.115 162.712 252.575 160.217 255.625 160.217C258.675 160.217 261.134 162.712 261.134 165.774C261.134 168.836 258.675 171.33 255.625 171.33C252.575 171.33 250.115 168.836 250.115 165.774Z"
      fill="#090A0B"
    />
    <path
      d="M169.317 165.772C169.317 176.391 160.793 184.999 150.279 184.999C139.764 184.999 131.24 176.391 131.24 165.772C131.24 155.153 139.764 146.545 150.279 146.545C160.793 146.545 169.317 155.153 169.317 165.772Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M150.279 147.295C140.185 147.295 131.99 155.56 131.99 165.772C131.99 175.984 140.185 184.249 150.279 184.249C160.372 184.249 168.567 175.984 168.567 165.772C168.567 155.56 160.372 147.295 150.279 147.295ZM130.49 165.772C130.49 154.746 139.343 145.795 150.279 145.795C161.215 145.795 170.067 154.746 170.067 165.772C170.067 176.798 161.215 185.749 150.279 185.749C139.343 185.749 130.49 176.798 130.49 165.772Z"
      fill="#090A0B"
    />
    <path
      d="M156.625 139C141.437 139 129.125 151.434 129.125 166.773H184.125C184.125 151.434 171.813 139 156.625 139Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M129.885 166.023H183.365C182.972 151.439 171.144 139.75 156.625 139.75C142.106 139.75 130.278 151.439 129.885 166.023ZM128.375 166.773C128.375 151.027 141.016 138.25 156.625 138.25C172.234 138.25 184.875 151.027 184.875 166.773V167.523H128.375V166.773Z"
      fill="#090A0B"
    />
    <path
      d="M175.663 165.772C175.663 176.391 167.14 184.999 156.625 184.999C146.11 184.999 137.586 176.391 137.586 165.772C137.586 155.153 146.11 146.545 156.625 146.545C167.14 146.545 175.663 155.153 175.663 165.772Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M156.625 147.295C146.531 147.295 138.336 155.56 138.336 165.772C138.336 175.984 146.531 184.249 156.625 184.249C166.718 184.249 174.913 175.984 174.913 165.772C174.913 155.56 166.718 147.295 156.625 147.295ZM136.836 165.772C136.836 154.746 145.689 145.795 156.625 145.795C167.561 145.795 176.413 154.746 176.413 165.772C176.413 176.798 167.561 185.749 156.625 185.749C145.689 185.749 136.836 176.798 136.836 165.772Z"
      fill="#090A0B"
    />
    <path
      d="M167.731 165.773C167.731 171.967 162.758 176.988 156.625 176.988C150.491 176.988 145.519 171.967 145.519 165.773C145.519 159.578 150.491 154.557 156.625 154.557C162.758 154.557 167.731 159.578 167.731 165.773Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M156.625 155.307C150.912 155.307 146.269 159.985 146.269 165.773C146.269 171.56 150.912 176.238 156.625 176.238C162.337 176.238 166.981 171.56 166.981 165.773C166.981 159.985 162.337 155.307 156.625 155.307ZM144.769 165.773C144.769 159.171 150.07 153.807 156.625 153.807C163.18 153.807 168.481 159.171 168.481 165.773C168.481 172.374 163.18 177.738 156.625 177.738C150.07 177.738 144.769 172.374 144.769 165.773Z"
      fill="#090A0B"
    />
    <path
      d="M161.384 165.774C161.384 168.428 159.254 170.58 156.625 170.58C153.996 170.58 151.865 168.428 151.865 165.774C151.865 163.119 153.996 160.967 156.625 160.967C159.254 160.967 161.384 163.119 161.384 165.774Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M156.625 161.717C154.417 161.717 152.615 163.526 152.615 165.774C152.615 168.021 154.417 169.83 156.625 169.83C158.832 169.83 160.634 168.021 160.634 165.774C160.634 163.526 158.832 161.717 156.625 161.717ZM151.115 165.774C151.115 162.712 153.575 160.217 156.625 160.217C159.675 160.217 162.134 162.712 162.134 165.774C162.134 168.836 159.675 171.33 156.625 171.33C153.575 171.33 151.115 168.836 151.115 165.774Z"
      fill="#090A0B"
    />
    <path
      d="M281.125 138C281.125 139.105 280.23 140 279.125 140C278.02 140 277.125 139.105 277.125 138C277.125 136.895 278.02 136 279.125 136C280.23 136 281.125 136.895 281.125 138Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M279.125 136.75C278.435 136.75 277.875 137.31 277.875 138C277.875 138.69 278.435 139.25 279.125 139.25C279.815 139.25 280.375 138.69 280.375 138C280.375 137.31 279.815 136.75 279.125 136.75ZM276.375 138C276.375 136.481 277.606 135.25 279.125 135.25C280.644 135.25 281.875 136.481 281.875 138C281.875 139.519 280.644 140.75 279.125 140.75C277.606 140.75 276.375 139.519 276.375 138Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M90.375 161C90.375 160.034 91.1585 159.25 92.125 159.25H110.125C111.091 159.25 111.875 160.034 111.875 161V162C111.875 162.966 111.091 163.75 110.125 163.75H92.125C91.1585 163.75 90.375 162.966 90.375 162V161ZM92.125 160.75C91.9869 160.75 91.875 160.862 91.875 161V162C91.875 162.138 91.9869 162.25 92.125 162.25H110.125C110.263 162.25 110.375 162.138 110.375 162V161C110.375 160.862 110.263 160.75 110.125 160.75H92.125Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M105.375 161C105.375 160.034 106.159 159.25 107.125 159.25H110.125C111.091 159.25 111.875 160.034 111.875 161V162C111.875 162.966 111.091 163.75 110.125 163.75H107.125C106.159 163.75 105.375 162.966 105.375 162V161ZM107.125 160.75C106.987 160.75 106.875 160.862 106.875 161V162C106.875 162.138 106.987 162.25 107.125 162.25H110.125C110.263 162.25 110.375 162.138 110.375 162V161C110.375 160.862 110.263 160.75 110.125 160.75H107.125Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.375 161C45.375 160.034 46.1585 159.25 47.125 159.25H57.125C58.0915 159.25 58.875 160.034 58.875 161V162C58.875 162.966 58.0915 163.75 57.125 163.75H47.125C46.1585 163.75 45.375 162.966 45.375 162V161ZM47.125 160.75C46.9869 160.75 46.875 160.862 46.875 161V162C46.875 162.138 46.9869 162.25 47.125 162.25H57.125C57.2631 162.25 57.375 162.138 57.375 162V161C57.375 160.862 57.2631 160.75 57.125 160.75H47.125Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M53.375 161C53.375 160.034 54.1585 159.25 55.125 159.25H57.125C58.0915 159.25 58.875 160.034 58.875 161V162C58.875 162.966 58.0915 163.75 57.125 163.75H55.125C54.1585 163.75 53.375 162.966 53.375 162V161ZM55.125 160.75C54.9869 160.75 54.875 160.862 54.875 161V162C54.875 162.138 54.9869 162.25 55.125 162.25H57.125C57.2631 162.25 57.375 162.138 57.375 162V161C57.375 160.862 57.2631 160.75 57.125 160.75H55.125Z"
      fill="#090A0B"
    />
    <path
      d="M236.125 83H236.462C243.251 83 249.722 85.8751 254.272 90.9131L273.616 112.33C274.197 112.973 273.741 114 272.874 114H243.125L236.125 83Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M235.187 82.25H236.462C243.463 82.25 250.137 85.215 254.829 90.4104L274.173 111.827C275.19 112.952 274.391 114.75 272.875 114.75H242.526L235.187 82.25ZM237.065 83.7578L243.725 113.25H272.875C273.091 113.25 273.205 112.993 273.06 112.832L253.716 91.4158C249.443 86.6847 243.421 83.9225 237.065 83.7578Z"
      fill="#090A0B"
    />
    <path
      d="M188.625 83H129.585C128.391 83 127.26 83.5334 126.5 84.4545L102.125 114H165.625L188.625 83Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M125.921 83.9772C126.824 82.8834 128.167 82.25 129.585 82.25H190.116L166.003 114.75H100.534L125.921 83.9772ZM129.585 83.75C128.615 83.75 127.696 84.1834 127.078 84.9318L103.716 113.25H165.248L187.135 83.75H129.585Z"
      fill="#090A0B"
    />
    <path
      d="M87.125 114.5H161.71C162.876 114.5 163.099 116.155 161.975 116.464L146.375 120.75L121.625 127H42.625L63.125 120.75L87.125 114.5Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M87.2531 115.5L161.71 115.5L146.12 119.783L121.501 126H49.3341L63.397 121.713L87.2531 115.5ZM63.125 120.75L87.125 114.5H161.71C162.876 114.5 163.099 116.155 161.975 116.464L146.375 120.75L121.625 127H42.625L63.125 120.75Z"
      fill="#090A0B"
    />
    <path
      d="M57.9624 74H132.959C133.584 74 134.173 74.2921 134.551 74.7895L163.905 113.395C164.405 114.053 163.936 115 163.109 115H89.137L57.9624 74Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M56.4497 73.25H132.959C133.818 73.25 134.628 73.6516 135.148 74.3355L164.501 112.941C165.377 114.093 164.556 115.75 163.108 115.75H88.7649L56.4497 73.25ZM59.4746 74.75L89.5087 114.25H163.108C163.315 114.25 163.433 114.013 163.307 113.849L133.954 75.2434C133.717 74.9325 133.349 74.75 132.959 74.75H59.4746Z"
      fill="#090A0B"
    />
    <path
      d="M37.832 74.2929C38.0195 74.1054 38.2739 74 38.5391 74H132.711C133.602 74 134.048 75.0771 133.418 75.7071L131.418 77.7071C131.23 77.8946 130.976 78 130.711 78H36.5391C35.6482 78 35.202 76.9229 35.832 76.2929L37.832 74.2929Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.3017 73.7626C37.6299 73.4344 38.075 73.25 38.5392 73.25H132.711C134.27 73.25 135.051 75.135 133.948 76.2374L131.948 78.2374C131.62 78.5656 131.175 78.75 130.711 78.75H36.5392C34.9801 78.75 34.1993 76.865 35.3017 75.7626L37.3017 73.7626ZM38.5392 74.75C38.4728 74.75 38.4093 74.7763 38.3624 74.8232L36.3624 76.8232C36.2049 76.9807 36.3164 77.25 36.5392 77.25H130.711C130.777 77.25 130.841 77.2237 130.888 77.1768L132.888 75.1768C133.045 75.0193 132.933 74.75 132.711 74.75H38.5392Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.8237 130.25H57.2212V143.75H44.8237V130.25ZM46.3237 131.75V142.25H55.7212V131.75H46.3237Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M89.5034 130.25H107.35V143.75H89.5034V130.25ZM91.0034 131.75V142.25H105.85V131.75H91.0034Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M105.85 130.25H123.125C124.644 130.25 125.875 131.481 125.875 133V141C125.875 142.519 124.644 143.75 123.125 143.75H105.85V130.25ZM107.35 131.75V142.25H123.125C123.816 142.25 124.375 141.69 124.375 141V133C124.375 132.31 123.816 131.75 123.125 131.75H107.35Z"
      fill="#090A0B"
    />
    <path d="M56.4712 131H90.2532V143H56.4712V131Z" fill="#090A0B" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M55.7212 130.25H91.0032V143.75H55.7212V130.25ZM57.2212 131.75V142.25H89.5032V131.75H57.2212Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M106.6 135.25C106.6 134.836 106.935 134.5 107.35 134.5H124.375C124.789 134.5 125.125 134.836 125.125 135.25C125.125 135.664 124.789 136 124.375 136H107.35C106.935 136 106.6 135.664 106.6 135.25Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M106.6 139.25C106.6 138.836 106.935 138.5 107.35 138.5H124.375C124.789 138.5 125.125 138.836 125.125 139.25C125.125 139.664 124.789 140 124.375 140H107.35C106.935 140 106.6 139.664 106.6 139.25Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M91.3429 136H55.3813V134.5H91.3429V136Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M91.3429 140H55.3813V138.5H91.3429V140Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.125 135.25C40.125 134.836 40.4608 134.5 40.875 134.5H44.8237C45.2379 134.5 45.5737 134.836 45.5737 135.25C45.5737 135.664 45.2379 136 44.8237 136H40.875C40.4608 136 40.125 135.664 40.125 135.25Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.125 139.25C40.125 138.836 40.4608 138.5 40.875 138.5H44.8237C45.2379 138.5 45.5737 138.836 45.5737 139.25C45.5737 139.664 45.2379 140 44.8237 140H40.875C40.4608 140 40.125 139.664 40.125 139.25Z"
      fill="#090A0B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.375 134C39.375 131.929 41.0539 130.25 43.125 130.25H46.3237V143.75H39.375V134ZM43.125 131.75C41.8824 131.75 40.875 132.757 40.875 134V142.25H44.8237V131.75H43.125Z"
      fill="#090A0B"
    />
    <path
      d="M182.125 112C182.125 110.895 183.02 110 184.125 110H198.125V118H184.125C183.02 118 182.125 117.105 182.125 116V112Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M181.375 112C181.375 110.481 182.606 109.25 184.125 109.25H198.875V118.75H184.125C182.606 118.75 181.375 117.519 181.375 116V112ZM184.125 110.75C183.435 110.75 182.875 111.31 182.875 112V116C182.875 116.69 183.435 117.25 184.125 117.25H197.375V110.75H184.125Z"
      fill="#090A0B"
    />
  </svg>
);
